module.exports = __webpack_public_path__ + "img/bg.daf2d62c.png";